export default "__VITE_ASSET__qtrElB4G__"